import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getErrorMessageByCode } from '@app/dev/constants/errorCodes';
import { PreferencesContext } from '@common/contexts/preferences';
import KeyboardInput from '@common/components/InputKeyboard';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import Loader from '@common/components/loader';
import { POPUPS } from '@common/constants/popups';
import Config from '@app/dev/config/main';
import { LoginAdmin, SetProfileError } from '../../../actions/terminal';
import { Login } from '../../../actions/login';

import './style.scss';

const LoginForm = ({ disableClose, signInToAdmin, onSuccessLogin }) => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [{ lang }] = useContext(PreferencesContext);

  useEffect(
    () => () => {
      dispatch(SetProfileError());
    },
    [],
  );

  const [form, setForm] = useState({
    username: '',
    password: '',
  });
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const displayLoginFailReason = (reason) => {
    if (!reason.data) {
      return reason.msg ? t(reason.msg) : t('Invalid username or password.');
    }
    return getErrorMessageByCode(reason.data.status);
  };

  const login = () => {
    if (signInToAdmin || form.username.includes('#')) {
      dispatch(LoginAdmin({ username: form.username, password: form.password }));
    } else {
      dispatch(Login(form.username, form.password, onSuccessLogin));
    }
  };

  return user.loginInProgress ? (
    <Loader />
  ) : (
    <div className="popup-content popup-small login-form-popup">
      <h3 className="popup-title">{t(`${signInToAdmin ? 'ADMIN' : 'Sign In'}`)}</h3>
      <div className="popup-main-content">
        <div className="input-wrapper">
          <p className="popup-txt">{Config.main.cpfType === 'cpfs' ? `CPF/ ${t('Username')}` : t('Login')}</p>
          <div className="input-row">
            <KeyboardInput
              enabled
              disableSearchIcon
              onChange={(value) => onChange('username', value)}
              value={form.username}
              lang={lang}
              class="popup-inp"
              placeholder={Config.main.registartionCustomField.placeHolder || ''}
            />
          </div>
          <p className="popup-txt">{t('Password')}</p>
          <div className="input-row">
            <KeyboardInput
              enabled
              disableSearchIcon
              onChange={(value) => onChange('password', value)}
              value={form.password}
              lang={lang}
              name="login-form-password"
              className="password-input"
            />
          </div>
        </div>

        {(user.profileError || user.loginFailReason) && (
          <div className="login-error">
            <span>{user.profileError ? t(user.profileError) : displayLoginFailReason(user.loginFailReason)}</span>
          </div>
        )}
      </div>
      <div className="popup-actions">
        {!disableClose && (
          <button
            type="button"
            onClick={closePopup}
            className="popup-cancel-button"
          >
            {t('Close')}
          </button>
        )}
        <button
          type="submit"
          className="popup-confirm-button"
          disabled={!form.username || !form.password}
          onClick={login}
        >
          {t('Login')}
        </button>
      </div>
      {
        (Config.main.enableRegistration && !signInToAdmin) && (
          <div
            className="register"
            onClick={() => openPopup(POPUPS.REGISTRATION_FORM, { popupPosition: 'top' })}
          >
            {t('Need an Account?')}
            &nbsp;
            <span>{t(`Register`)}</span>
          </div>
        )
      }
    </div>
  );
};

export default LoginForm;
